module.exports = __webpack_public_path__ + "static/media/sb.4e669121.jpg";